<script>
  import PageTitle from '$lib/teach/resources/PageTitle.svelte';
</script>

<div class="article">
  <PageTitle
    doNotAutoCapitalize
    title="uTheory Experiments"
    description="Work-in-progress exercises for uTheory. Try them
  out before they are included in uTheory's suite of music theory and ear training exercises"
  />

  <div class="xs:flex max-h-screen space-x-2 mx-auto w-fit flex-wrap">
    <div class="my-2 text-center">
      <a class="a" href="/experiments/solfege-sally">
        <img
          class="w-52 md:w-80 lg:w-96"
          src="/assets/solfege-sally/solfege-sally-experiments-button.png"
          alt="The Solfege Sally game: A black circle with the words Solfege Sally in the middle, surrounded by colorful buttons labeled Do Re Mi Fa Sol La Ti Do."
        />
        Solfege Sally
      </a>
    </div>
    <div class="my-2 text-center">
      <a class="a" href="/experiments/pitchy-fish">
        <img
          class="w-52 md:w-80 lg:w-96"
          src="/assets/pitchy-fish/pitchy-fish-experiments-button.jpg"
          alt="The Pitchy Fish game, showing a fish swimming between gaps in piers, controlled by singing higher and lower."
        />
        Pitchy Fish
      </a>
    </div>
  </div>
</div>
